// @flow
import React, { PureComponent, Fragment } from "react";
import Icon from "../../_static/Icons";
import { video, tvgChannel1, tvgChannel2 } from "../../_static/Icons/icons";

import buildColor from "../../_static/ColorPalette";
import {
  WatchLiveLabel,
  ButtonContainer,
  TvgLiveLink
} from "./styled-components";

type Props = {
  className: ?string,
  tvg1Link: ?string,
  tvg2Link: ?string
};

export default class LiveButtonsGroup extends PureComponent<Props> {
  static defaultProps = {
    className: "",
    tvg1Link: null,
    tvg2Link: null
  };

  renderMainBlock = () => (
    <Fragment>
      {this.props.tvg1Link && (
        <TvgLiveLink to={this.props.tvg1Link} data-qa-label="tvg-live-channel1">
          <ButtonContainer>
            <Icon
              size={62}
              icon={tvgChannel1}
              color={buildColor("white", "100")}
            />
            <WatchLiveLabel>
              <Icon size={16} icon={video} color={buildColor("white", "100")} />
              Watch TVG
            </WatchLiveLabel>
          </ButtonContainer>
        </TvgLiveLink>
      )}

      {this.props.tvg2Link && (
        <TvgLiveLink to={this.props.tvg2Link} data-qa-label="tvg-live-channel2">
          <ButtonContainer>
            <Icon
              size={62}
              icon={tvgChannel2}
              color={buildColor("white", "100")}
            />
            <WatchLiveLabel>
              <Icon size={16} icon={video} color={buildColor("white", "100")} />
              Watch TVG2
            </WatchLiveLabel>
          </ButtonContainer>
        </TvgLiveLink>
      )}
    </Fragment>
  );

  render() {
    return this.props.className ? (
      <div className={this.props.className}>{this.renderMainBlock()}</div>
    ) : (
      this.renderMainBlock()
    );
  }
}
